import $ from 'jquery';
const log = require('debug')('linksoft:auto-query-helper');
import navigator from './internal/navigator';
import querystring from './querystring';
import queryFilter from './queryFilter';

export default function (element) {
    const $this = $(element);
    const type = $this.attr('data-query');
    const key = $this.attr('name') || $this.attr('id');
    const value = getValue(type, $this.val());
    const dataFilterValue = $this.attr('data-filter');
    const invert = $this.attr('data-invert') === 'true';
    const queryObject = {};

    if ($this.is(':checkbox')) {
        const checkboxes = $(`input:checkbox[name="${key}"]`);
        if (checkboxes.length > 1 || dataFilterValue === 'array') { //
            let checkboxValues = checkboxes
                .filter(':checked')
                .map(function () {
                    return getValue(type, this.value);
                }).get();
            log('checkboxValues: %o', checkboxValues);
            queryObject[key] = checkboxValues;
        } else {
            if(invert) {
                queryObject[key] = $this.is(':checked') ? null : value;
            } else {
                queryObject[key] = $this.is(':checked') ? value : null;
            }
        }
    }
    else if ($this.is(':radio')){
        queryObject[key] = $this.is(':checked') ? value : null;
    } else {
        queryObject[key] = value;
    }

    updateQuery($this, queryObject);
};

export function updateQuery($element, queryObject) {
    if ($element.is('[data-filter]')) {
        let origFilter = querystring.parse(window.location.href).filter;
        queryObject = { filter: queryFilter.combine(origFilter, queryObject), page: null};
    }
    navigator.navigate(queryObject, $element);
};


function getValue(type, value) {
    switch (type)
    {
        case 'json':
            return JSON.parse(value);
        case 'boolean':
            return value === 'true';
        case 'string':
        default:
            return value;
    }
}


// WEBPACK FOOTER //
// ./node_modules/linksoft/src/autoQueryHelper.js